import { $el, $elParent } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'
import { ProductForm } from './product-form'

const FOOTER_SELECTOR = '.shopify-section.shopify-section-footer'
const FORM_SELECTOR = 'product-form'

export class ProductFormButton extends BaseComponent {
  mountComponent(): void {
    this.addListener(window, 'scroll', this.handleWindowScroll)

    if (window.visualViewport) {
      window.visualViewport.addEventListener(
        'resize',
        this.handleResizeVisualViewport,
      )

      this.handleResizeVisualViewport()
    }
  }

  handleWindowScroll = (): void => {
    const form: ProductForm = $elParent(FORM_SELECTOR, this)

    if (!form) {
      return
    }

    const footer = $el(FOOTER_SELECTOR)
    const point = form.offsetTop + form.offsetHeight
    const footerOffsetTop = footer ? footer.offsetTop : 0
    const isOverFooter = window.innerHeight + window.scrollY < footerOffsetTop
    const isVisible = isOverFooter && window.scrollY > point

    this.classList.toggle('is-visible', isVisible)
    document.body.toggleAttribute('is-product-form-button-fixed', isVisible)
    document
      .querySelector('.call-us-container-mb')
      ?.classList.toggle('is-top', isVisible)
  }

  handleResizeVisualViewport = () => {
    if (window.visualViewport) {
      // The customized sticky ATC is anchored with `bottom: 0`. Keeping the
      // original theme's inline `top` value constrains the host to its
      // vertical padding and pushes the actual button below the viewport.
      // Offset the bottom edge only when the visual viewport is reduced (for
      // example by an on-screen keyboard), and make sure no stale top value
      // remains.
      const bottomOffset = Math.max(
        0,
        window.innerHeight -
          window.visualViewport.height -
          window.visualViewport.offsetTop,
      )

      this.style.removeProperty('top')
      this.style.bottom = `${bottomOffset}px`
    }
  }
}
